import { InjectionToken, Type } from "@angular/core";

export const CUSTOM_VIEW_REGISTRY = new InjectionToken<ReadonlyArray<CustomComponentRegistry>>("CUSTOM_VIEW_REGISTRY");

/**
 * Maps custom components to a key that is expected to be the components selector.
 *
 * Note: I don't want the registry to bound to only ICustomViewComponent<unknown> since that will affect downstream
 * where I do want more type-safety
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type CustomComponentRegistry = Record<string, Type<ICustomViewComponent<any>>>;

export interface ICustomViewComponent<T = unknown>
{
    customDataBinding: T;
}

/**
 * @private DO NOT EXPORT OUTSIDE OF MODULE
 */
export interface CustomViewConfig<T>
{
    readonly customView: CustomViewItem<T>;
    readonly data: T;
}

/**
 * @private DO NOT EXPORT OUTSIDE OF MODULE
 */
export class CustomViewItem<T = unknown>
{
    constructor(public readonly component: Type<ICustomViewComponent<T>>) { }
}
